var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.95 3.80772C16.873 2.73076 15.127 2.73076 14.05 3.80772L8.92893 8.92878C5.02369 12.834 5.02369 19.1657 8.92893 23.0709C10.6269 24.7689 12.7835 25.7286 15 25.95V29.0004C15 29.5527 15.4477 30.0004 16 30.0004C16.5523 30.0004 17 29.5527 17 29.0004V25.95C19.2165 25.7286 21.3731 24.7689 23.0711 23.0709C26.9763 19.1657 26.9763 12.834 23.0711 8.92878L17.95 3.80772ZM17 23.9375V15.0004C17 14.4482 16.5523 14.0004 16 14.0004C15.4477 14.0004 15 14.4482 15 15.0004V23.9375C13.2975 23.7242 11.6504 22.9639 10.3431 21.6567C7.21895 18.5325 7.21895 13.4672 10.3431 10.343L15.4642 5.22193C15.7601 4.92602 16.2399 4.92602 16.5358 5.22193L21.6569 10.343C24.781 13.4672 24.781 18.5325 21.6569 21.6567C20.3496 22.9639 18.7025 23.7242 17 23.9375Z",
    fill: "#131542"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf);
export default __webpack_public_path__ + "static/media/leaf.98c60d4a83160a1bd197329ca3745b79.svg";
export { ForwardRef as ReactComponent };